import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { formatTimestampToPortalTz } from 'flow-doctor-lib/utils/dateTimeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const UnknownEnrollmentAnalysisDetails = ({
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDescription.default.description_jsx',
    elements: {
      ObjectNameLabel,
      b: 'b'
    },
    options: {
      objectName: {
        portalId: selectedEnrollment.portalId,
        objectTypeId: selectedEnrollment.objectTypeId,
        objectId: selectedEnrollment.objectId,
        showId: getIsInternal()
      },
      timestamp: formatTimestampToPortalTz(selectedEnrollment.timestamp)
    }
  });
};
export default UnknownEnrollmentAnalysisDetails;